import { numberFormatter } from "@common/helpers/number";
import { TRANSACTIONS_PAGE_SIZE } from "@components/transactions/useTransactionsQuery";
import React from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { CloseIcon } from "@icons";
import { useBulkActions } from "../useBulkActions";
import styles from "./TransactionsActionBar.module.scss";

export const SelectionControls: React.FC = () => {
    const {
        selectedCount,
        hasSelectedAll,
        totalTransactions,
        clearSelection,
        selectAll,
    } = useBulkActions();

    return (
        <>
            <Tooltip content={`Deselect ${selectedCount}`}>
                <button
                    className={styles.textContainer}
                    onClick={clearSelection}
                    style={{
                        border: 0,
                        background: "transparent",
                        cursor: "pointer",
                    }}
                >
                    <span className={styles.selectedItemsText}>
                        {selectedCount} Selected
                        <CloseIcon className="ml-2" width={12} height={12} />
                    </span>
                </button>
            </Tooltip>
            {!hasSelectedAll && totalTransactions > TRANSACTIONS_PAGE_SIZE ? (
                <>
                    <span className={styles.separator} />
                    <button
                        type="button"
                        className={styles.button}
                        onClick={selectAll}
                        data-testid="bulk-select-all-button"
                    >
                        Select all {numberFormatter.format(totalTransactions)}
                    </button>
                </>
            ) : null}
        </>
    );
};
